import { saveAs as importedSaveAs } from "file-saver";

import { workingHoursPerDay } from "./constants";

const excludedItemsForMonthly = [
  "ITD",
  "Remaining Forecast",
  "Total",
  "Other Year Actual",
  "Other Year Forecast",
];

const excludedItemsForMonthlyForecast = [
  "ITD",
  "Remaining Forecast",
  "Total",
  "Other Year Actual",
];

export const getMonthOnly = (dateStr) => parseInt(dateStr?.split("-")[1]);

export const getYearOnly = (dateStr) => parseInt(dateStr?.split("-")[0]);

export const getDateOnly = (dateStr) => parseInt(dateStr?.split("-")[2]);

const excludedItemsForMonthlyOther = ["ITD", "Remaining Forecast", "Total"];

const IncludeItemsForTotal = [
  "ITD",
  "Other Year Actual",
  "Other Year Forecast",
];
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
};

const daysBetweenDates = (startDateStr, endDateStr) => {
  // Convert YYYY-MM-DD strings to UTC Date objects
  const [startY, startM, startD] = startDateStr.split("-").map(Number);
  const [endY, endM, endD] = endDateStr.split("-").map(Number);

  const startDate = new Date(Date.UTC(startY, startM - 1, startD));
  const endDate = new Date(Date.UTC(endY, endM - 1, endD));

  let count = 0;
  const current = new Date(startDate.getTime());

  while (current < endDate) {
    const day = current.getUTCDay(); // Use UTC day!
    if (day !== 0 && day !== 6) count++; // skip weekends
    current.setUTCDate(current.getUTCDate() + 1); // move to next UTC day
  }

  return count;
};

export const getTimeZomeOffDate = () => {
  let d = new Date();
  let year = d.getFullYear();
  let month = d.getMonth();
  let day = d.getDate();
  let date = new Date(Date.UTC(year, month, day));
  return date.toISOString().split("T")[0];
};

export const downloadFile = (data, name) => {
  if (data) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data);
    } else {
      importedSaveAs(data, `${name}_${new Date().getTime()}.xlsx`);
    }
  }
};

export const downloadFileNoTimeStamp = (data, name) => {
  if (data) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data);
    } else {
      importedSaveAs(data, `${name}.xlsx`);
    }
  }
};

export const getFirstDateOfMonth = (year, monthIndex) => {
  return new Date(year, monthIndex, 1);
};

export const getLastDateOfMonth = (year, month) => {
  // The 'month' parameter is 0-indexed (0 = January, 11 = December).
  // Creating a new date with the NEXT month and a day of '0'
  // automatically refers to the last day of the PREVIOUS month.
  return new Date(year, month + 1, 0);
};

export const getBusinessDatesCount = (startDate, endDate) => {
  let count = 0;
  const curDate = new Date(startDate.getTime());
  while (curDate < endDate) {
    const dayOfWeek = curDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
    curDate.setDate(curDate.getDate() + 1);
  }
  return count;
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
export const convertCurrency = (labelValue, currency = "") => {
  if (!labelValue || isNaN(labelValue)) {
    return "";
  }

  if (currency === "%") return `${labelValue}${currency}`;

  let convertNumber = 0;
  convertNumber =
    Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9)
          .toFixed(2)
          .replace(/\.?0*$/, "")
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "B"
      : Math.abs(Number(labelValue)) >= 1.0e6
        ? (Math.abs(Number(labelValue)) / 1.0e6)
            .toFixed(2)
            .replace(/\.?0*$/, "")
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "M"
        : Math.abs(Number(labelValue)) >= 1.0e3
          ? (Math.abs(Number(labelValue)) / 1.0e3)
              .toFixed(2)
              .replace(/\.?0*$/, "")
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "K"
          : Math.abs(Number(labelValue))
              .toFixed(2)
              .replace(/\.?0*$/, "")
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const lastChar = convertNumber.charAt(convertNumber.length - 1);
  const lastToChar = convertNumber.charAt(convertNumber.length - 2);

  if (lastChar === "0")
    convertNumber = convertNumber.substring(0, convertNumber.length - 2);
  else if (
    (lastChar === "B" || lastChar === "M" || lastChar === "K") &&
    lastToChar === "0" &&
    convertNumber.charAt(convertNumber.length - 2) === "0"
  ) {
    convertNumber =
      convertNumber.substring(0, convertNumber.length - 3) + lastChar;
  }

  return currency !== "" ? `${currency}${convertNumber}` : `${convertNumber}`;
};

export const convertCurrencyTwoDecimals = (labelValue, currency) => {
  if (currency === "%") return `${labelValue}${currency}`;
  let convertNumber = 0;
  convertNumber =
    Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "B"
      : Math.abs(Number(labelValue)) >= 1.0e6
        ? (Math.abs(Number(labelValue)) / 1.0e6)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "M"
        : Math.abs(Number(labelValue)) >= 1.0e3
          ? (Math.abs(Number(labelValue)) / 1.0e3)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "K"
          : Math.abs(Number(labelValue))
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const lastChar = convertNumber.charAt(convertNumber.length - 1);
  const lastToChar = convertNumber.charAt(convertNumber.length - 2);
  if (lastChar === "0")
    convertNumber = convertNumber.substring(0, convertNumber.length - 2);
  else if (
    (lastChar === "B" || lastChar === "M" || lastChar === "K") &&
    lastToChar === "0" &&
    convertNumber.charAt(convertNumber.length - 2) === "0"
  ) {
    convertNumber =
      convertNumber.substring(0, convertNumber.length - 3) + lastChar;
  }
  if (labelValue >= 0) return `${currency}${convertNumber}`;
  else return `(${currency}${convertNumber})`;
};

export const convertValues = (labelValue, type = "$") => {
  const convertNumber =
    Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9)
          .toFixed(0)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "B"
      : Math.abs(Number(labelValue)) >= 1.0e6
        ? (Math.abs(Number(labelValue)) / 1.0e6)
            .toFixed(0)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "M"
        : Math.abs(Number(labelValue)) >= 1.0e3
          ? (Math.abs(Number(labelValue)) / 1.0e3)
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "K"
          : Math.abs(Number(labelValue))
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(labelValue) < 0
    ? `(${type}${convertNumber.replace("-", "")})`
    : `${type}${convertNumber}`;
};

export const convertValuesFM = (labelValue, type = "$") => {
  if (isNaN(labelValue)) return `${type}0`;
  let convertNumber = Math.round(Number(labelValue) * 100) / 100;
  convertNumber = convertNumber
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(labelValue) < 0
    ? `(${type}${convertNumber.replace("-", "")})`
    : `${type}${convertNumber}`;
};
export const validateTwoDecimals = (value) => {
  if (value === "" || value === undefined || value === null) return "";
  const stringValue = value.toString();
  // Allow digits, one dot, and up to 2 digits after dot
  const regex = /^\d*\.?\d{0,2}$/;
  if (regex.test(stringValue)) {
    return stringValue;
  } else {
    // Trim extra decimals
    const parts = stringValue.split(".");
    if (parts.length > 1) {
      return parts[0] + "." + parts[1].substring(0, 2);
    }
    return parts[0];
  }
};

export const convertValuesFMPipeline = (labelValue, type = "$") => {
  if (isNaN(labelValue)) return `${type}0`;
  let convertNumber = Math.round(Number(labelValue) * 100) / 100;
  convertNumber = convertNumber
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(labelValue) < 0
    ? `(${type}${convertNumber.replace("-", "")})`
    : `${type}${convertNumber}`;
};
export const formatNumberWithCommas = (value) => {
  if (isNaN(value)) return "0";

  let number = Number(value);

  let [integerPart, decimalPart] = number.toString().split(".");

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
};

export const convertValuesPipeline = (labelValue, type = "$") => {
  if (isNaN(labelValue)) return `${type}0`;

  // Take only the integer part (truncates decimals)
  let integerPart = Math.trunc(Number(labelValue)).toString();

  // Add commas to integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Handle negatives with parentheses
  return Number(labelValue) < 0
    ? `(${type}${integerPart.replace("-", "")})`
    : `${type}${integerPart}`;
};

export const convertValuesFMPipelineNoRound = (labelValue, type = "$") => {
  if (isNaN(labelValue)) return `${type}0`;
  let convertNumber = Math.round(labelValue);
  convertNumber = convertNumber
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(labelValue) < 0
    ? `(${type}${convertNumber.replace("-", "")})`
    : `${type}${convertNumber}`;
};

export const convertValuesFMNoRoundoff = (labelValue, type = "$") => {
  if (isNaN(labelValue)) return `${type}0`;
  let convertNumber = Number(labelValue);
  convertNumber = convertNumber
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(labelValue) < 0
    ? `(${type}${convertNumber.replace("-", "")})`
    : `${type}${convertNumber}`;
};

export const fixedToTwoDecimals = (value) => {
  if (isNaN(value)) return 0;
  let fixedValue = value.toFixed(2);
  if (fixedValue.substr(fixedValue.length - 1) === "0")
    fixedValue = value.toFixed(1);
  if (fixedValue.substr(fixedValue.length - 1) === "0")
    fixedValue = value.toFixed(0);
  return fixedValue;
};

export const fixedToTwoDecimalsInteger = (value) => {
  if (isNaN(value)) return 0;
  let fixedValue = Math.round(value * 100) / 100;
  if (fixedValue.toString().substr(fixedValue.length - 1) === "0")
    fixedValue = Math.round(value * 10) / 10;
  if (fixedValue.toString().substr(fixedValue.length - 1) === "0")
    fixedValue = value;
  return fixedValue;
};

export const getResponse = (res, defaultData) => {
  if (res.status && res.status === 200 && res.data) return res.data;
  else return defaultData;
};

export const getComponentPermissionEnabled = (settingsData, key, item) => {
  let isEnabled = false;
  if (
    settingsData.componentSettings &&
    settingsData.componentSettings.length > 0 &&
    settingsData.componentSettings.filter((val) => val.fields === item).length >
      0
  )
    isEnabled = settingsData.componentSettings.filter(
      (val) => val.fields === item,
    )[0][key];
  return isEnabled;
};

export const getButtonPermissionEnabled = (settingsData, key, item) => {
  let isEnabled = false;
  if (
    settingsData.buttonSettings &&
    settingsData.buttonSettings.length > 0 &&
    settingsData.buttonSettings.filter((val) => val.fields === item).length > 0
  )
    isEnabled = settingsData.buttonSettings.filter(
      (val) => val.fields === item,
    )[0][key];
  return isEnabled;
};

export const getEditAccess = (settingsData, key, item) => {
  let isHaveAccess = false;
  if (settingsData.filter((val) => val.fields === item).length > 0)
    isHaveAccess = settingsData.filter((val) => val.fields === item)[0][key];
  return isHaveAccess;
};

export const getColorBySetting = (data, item, val) => {
  return data
    .filter((setItem) => setItem.fields === item)[0]
    .adminPicklistSettingsList.filter((pickItem) => pickItem.name === val)
    .length > 0
    ? data
        .filter((setItem) => setItem.fields === item)[0]
        .adminPicklistSettingsList.filter(
          (pickItem) => pickItem.name === val,
        )[0].color
    : "#000000";
};

export const checkColumnDuplicate = (data, value, key) => {
  return (
    data.filter(
      (val) =>
        val[key].toLowerCase().trim().replace(/\s\s+/g, " ") ===
        value.toLowerCase().trim().replace(/\s\s+/g, " "),
    ).length > 0
  );
};

export const convertToNumber = (numberVal) => {
  if (numberVal) {
    let val = numberVal.toString().replace("$", "");
    val = val.replace(",", "");
    val = val.replace("%", "");
    if (val.includes("B")) val = parseFloat(val.replace("B", "")) * 1.0e9;
    else if (val.includes("M")) val = parseFloat(val.replace("M", "")) * 1.0e6;
    else if (val.includes("K")) val = parseFloat(val.replace("K", "")) * 1.0e3;
    else val = parseFloat(val);
    return parseFloat(val);
  }
  return 0;
};

export const convertToPlain = (html) => {
  // Create a new div element
  var tempDivElement = document.createElement("div");

  // Set the HTML content with the given value
  tempDivElement.innerHTML = html;

  // Retrieve the text property of the element
  return tempDivElement.textContent || tempDivElement.innerText || "";
};

export const converDateFormatForPicker = (format) => {
  let changedFormat = format?.replaceAll("D", "d")?.replaceAll("Y", "y");
  return changedFormat;
};

export const formatDateBySetting = (date, formatType) => {
  if (date && date.toString() !== "Invalid Date") {
    const monthVal = date.getMonth() + 1;
    const month =
      monthVal.toString().length === 2
        ? monthVal.toString()
        : `0${monthVal.toString()}`;
    const dateVal =
      date.getDate().toString().length === 2
        ? date.getDate().toString()
        : `0${date.getDate().toString()}`;
    const year = date.getFullYear().toString().substr(-2);
    const fullYear = date.getFullYear().toString();
    if (formatType.toUpperCase() === "DD/MM/YY")
      return dateVal + "/" + month + "/" + year;
    if (formatType.toUpperCase() === "DD-MM-YY")
      return dateVal + "-" + month + "-" + year;
    if (formatType.toUpperCase() === "DD/MM/YYYY")
      return dateVal + "/" + month + "/" + fullYear;
    if (formatType.toUpperCase() === "DD-MM-YYYY")
      return dateVal + "-" + month + "-" + fullYear;
    if (formatType.toUpperCase() === "MM/DD/YY")
      return month + "/" + dateVal + "/" + year;
    if (formatType.toUpperCase() === "MM-DD-YY")
      return month + "-" + dateVal + "-" + year;
    if (formatType.toUpperCase() === "MM/DD/YYYY")
      return month + "/" + dateVal + "/" + fullYear;
    if (formatType.toUpperCase() === "MM-DD-YYYY")
      return month + "-" + dateVal + "-" + fullYear;
    if (formatType.toUpperCase() === "YYYY/MM/DD")
      return fullYear + "/" + month + "/" + dateVal;
    if (formatType.toUpperCase() === "YYYY-MM-DD")
      return fullYear + "-" + month + "-" + dateVal;
  }
  return ``;
};

export const formatBackToDateFromSetting = (date, formatType) => {
  if (date && date !== "" && date.toString() !== "Invalid Date") {
    if (formatType.toUpperCase() === "DD/MM/YY") {
      return new Date(
        date.split("/")[1] +
          "/" +
          date.split("/")[0] +
          "/" +
          date.split("/")[2],
      );
    }
    if (formatType.toUpperCase() === "DD-MM-YY") {
      return new Date(
        date.split("-")[1] +
          "/" +
          date.split("-")[0] +
          "/" +
          date.split("-")[2],
      );
    }
    if (formatType.toUpperCase() === "DD/MM/YYYY") {
      return new Date(
        date.split("/")[1] +
          "/" +
          date.split("/")[0] +
          "/" +
          date.split("/")[2],
      );
    }
    if (formatType.toUpperCase() === "DD-MM-YYYY") {
      return new Date(
        date.split("-")[1] +
          "/" +
          date.split("-")[0] +
          "/" +
          date.split("-")[2],
      );
    }
    if (
      formatType.toUpperCase() === "MM/DD/YY" ||
      formatType.toUpperCase() === "MM-DD-YY" ||
      formatType.toUpperCase() === "MM/DD/YYYY" ||
      formatType.toUpperCase() === "MM-DD-YYYY"
    ) {
      return new Date(date);
    }
    if (formatType.toUpperCase() === "YYYY/MM/DD") {
      return new Date(
        date.split("/")[1] +
          "/" +
          date.split("/")[2] +
          "/" +
          date.split("/")[0],
      );
    }
    if (formatType.toUpperCase() === "YYYY-MM-DD") {
      return new Date(
        date.split("-")[1] +
          "/" +
          date.split("-")[2] +
          "/" +
          date.split("-")[0],
      );
    }
    return ``;
  }
};
export const isWeekday = (date) => {
  const day = date.getDay();
  return day !== 0 && day !== 6;
};

export const getMonthValueByName = (month) => {
  let start = 0;
  if (month) {
    if (month === "february") start = 1;
    if (month === "march") start = 2;
    if (month === "april") start = 3;
    if (month === "may") start = 4;
    if (month === "june") start = 5;
    if (month === "july") start = 6;
    if (month === "august") start = 7;
    if (month === "september") start = 8;
    if (month === "october") start = 9;
    if (month === "november") start = 10;
    if (month === "december") start = 11;
  }
  return start;
};

export const getMonthNameByValue = (month) => {
  let start = "January";
  if (month) {
    if (month === 1) start = "February";
    if (month === 2) start = "March";
    if (month === 3) start = "April";
    if (month === 4) start = "May";
    if (month === 5) start = "June";
    if (month === 6) start = "July";
    if (month === 7) start = "August";
    if (month === 8) start = "September";
    if (month === 9) start = "October";
    if (month === 10) start = "November";
    if (month === 11) start = "December";
  }
  return start;
};

const hexToRgbA = (hex) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",1)"
    );
  }
  return "#000000";
};

export const getContrastColor = (hexcolor) => {
  var r = parseInt(hexcolor.substring(1, 3), 16);
  var g = parseInt(hexcolor.substring(3, 5), 16);
  var b = parseInt(hexcolor.substring(5, 7), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
};

export const daysInMonth = (iMonth, iYear) => {
  return 32 - new Date(iYear, iMonth, 32).getDate();
};

export const AddCommas = (value) => {
  if (value === "" || value === 0 || value == null) return 0;
  const str = String(value);
  const [intPart, decPart] = str.split(".");
  const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decPart !== undefined ? `${formatted}.${decPart}` : formatted;
};

export const isWeekdayByMonth = (year, month, day) => {
  var day = new Date(year, month, day).getDay();
  return day != 0 && day != 6;
};

export const getWeekdaysInMonth = (month, year) => {
  var zeroIndexedMonth = month - 1;
  var days = daysInMonth(zeroIndexedMonth, year);
  var weekdays = 0;
  for (var i = 0; i < days; i++) {
    if (isWeekdayByMonth(year, zeroIndexedMonth, i + 1)) weekdays++;
  }
  return weekdays;
};

export const checkIfOnlyDM = () => {
  return false;
};

export const hasUpper = (str) => {
  return /[A-Z]/.test(str.trim());
};

export const hasSpecialCharacter = (str) => {
  return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str.trim());
};

export const hasNumber = (str) => {
  return /\d/.test(str.trim());
};

export const getPaginationPageNumber = (page, len, rowsPerPage) => {
  const start = page * rowsPerPage + 1;
  let end = page * rowsPerPage + rowsPerPage;
  if (end > len) end = len;
  if (len === 1) return `1`;
  return `${start}-${end}`;
};

export const handleResourceRequest = () => {
  const newlyAddedResource =
    (localStorage.getItem("newlyAddedResource") &&
      JSON.parse(localStorage.getItem("newlyAddedResource"))) ||
    [];
  let resourceNames = [];
  newlyAddedResource.forEach((val) => {
    resourceNames.push(val.resourceName);
  });

  if (resourceNames.length >= 1) {
    let message;
    if (resourceNames.length === 1) {
      message = `You have requested resource (${resourceNames.join(
        ", ",
      )}) but you haven't requested any time for this resource!`;
    } else if (resourceNames.length > 1) {
      message = `You have requested resources (${resourceNames.join(
        ", ",
      )}) but you haven't requested any time for those resources!`;
    }

    if (window.confirm(message)) {
      localStorage.removeItem("newlyAddedResource");
      return true;
    } else {
      return false;
    }
  }
  return true;
};

//Begin of direct labor cost calculations

export const calculateTotalDirectLabor = (data, key, monthYear) => {
  let sumValue = 0;
  if (data && data.getDirectLaborDetailList)
    data.getDirectLaborDetailList.forEach((item) => {
      item.monthExpenseDetail.forEach((monthItem) => {
        if (monthItem.monthYear === monthYear)
          sumValue += Number(monthItem[key]) || 0;
      });
    });
  if (data && data.adjustment)
    if (
      data.adjustment.filter((item) => item.monthYear === monthYear).length > 0
    )
      sumValue +=
        Number(
          data.adjustment.filter((item) => item.monthYear === monthYear)[0][
            key
          ],
        ) || 0;
  return sumValue;
};

export const calculateRemainingForecastDirectLabor = (data, key, dlId) => {
  let sumValue = 0;
  if (data && data.getDirectLaborDetailList)
    data.getDirectLaborDetailList
      .filter((val) => val.dlId === dlId)
      .forEach((item) => {
        item.monthExpenseDetail.forEach((monthItem) => {
          if (
            monthItem.type.toLowerCase() === "forecast" &&
            (excludedItemsForMonthly.indexOf(monthItem.monthYear) < 0 ||
              monthItem.monthYear === "Other Year Forecast")
          ) {
            sumValue += Number(monthItem[key]) || 0;
          }
        });
      });
  return sumValue;
};

export const calculateRemainingForecastDirectLaborTotal = (data, key) => {
  let sumValue = 0;
  if (data && data.getDirectLaborDetailList)
    data.getDirectLaborDetailList.forEach((item) => {
      item.monthExpenseDetail.forEach((monthItem) => {
        if (
          monthItem.type.toLowerCase() === "forecast" &&
          (excludedItemsForMonthly.indexOf(monthItem.monthYear) < 0 ||
            monthItem.monthYear === "Other Year Forecast")
        )
          sumValue += Number(monthItem[key]) || 0;
      });
    });
  if (data && data.adjustment)
    data.adjustment
      .filter(
        (item) =>
          item.type.toLowerCase() === "forecast" &&
          (excludedItemsForMonthly.indexOf(item.monthYear) < 0 ||
            item.monthYear === "Other Year Forecast"),
      )
      .forEach((val) => {
        sumValue += Number(val[key]) || 0;
      });
  return sumValue;
};

export const calculateRemainingForecastDirectLaborAdjustment = (data, key) => {
  let sumValue = 0;
  if (data && data.adjustment)
    data.adjustment
      .filter(
        (item) =>
          item.type.toLowerCase() === "forecast" &&
          (excludedItemsForMonthly.indexOf(item.monthYear) < 0 ||
            item.monthYear === "Other Year Forecast"),
      )
      .forEach((val) => {
        sumValue += Number(val[key]) || 0;
      });
  return sumValue;
};

export const calculateItemTotalDirectLabor = (data, key, dlId) => {
  let sumValue = 0;
  if (data && data.getDirectLaborDetailList)
    data.getDirectLaborDetailList
      .filter((val) => val.dlId === dlId)
      .forEach((item) => {
        item.monthExpenseDetail.forEach((monthItem) => {
          if (excludedItemsForMonthlyOther.indexOf(monthItem.monthYear) < 0)
            sumValue += Number(monthItem[key]) || 0;
        });
      });
  return sumValue;
};

export const calculateItemTotalDirectLaborTotal = (data, key) => {
  let sumValue = 0;
  if (data && data.getDirectLaborDetailList)
    data.getDirectLaborDetailList.forEach((item) => {
      item.monthExpenseDetail.forEach((monthItem) => {
        if (excludedItemsForMonthlyOther.indexOf(monthItem.monthYear) < 0)
          sumValue += Number(monthItem[key]) || 0;
      });
    });
  if (data && data.adjustment)
    data.adjustment.forEach((val) => {
      if (excludedItemsForMonthlyOther.indexOf(val.monthYear) < 0)
        sumValue += Number(val[key]) || 0;
    });
  return sumValue;
};

export const calculateItemTotalDirectLaborAdjustment = (data, key) => {
  let sumValue = 0;
  if (data && data.adjustment)
    data.adjustment
      .filter(
        (item) => excludedItemsForMonthlyOther.indexOf(item.monthYear) < 0,
      )
      .forEach((val) => {
        sumValue += Number(val[key]) || 0;
      });
  return sumValue;
};

//End of direct labor cost calculations

//Begin of other direct cost calculations

export const calculateTotalOtherDirectCost = (data, key, monthYear) => {
  let sumValue = 0;
  if (data && data.otherDirectLabourDetailList)
    data.otherDirectLabourDetailList.forEach((item) => {
      item.monthExpenseDetail.forEach((monthItem) => {
        if (monthItem.monthYear === monthYear)
          sumValue += Number(monthItem[key]) || 0;
      });
    });
  if (data && data.adjustment)
    if (
      data.adjustment.filter((item) => item.monthYear === monthYear).length > 0
    )
      sumValue +=
        Number(
          data.adjustment.filter((item) => item.monthYear === monthYear)[0][
            key
          ],
        ) || 0;
  return sumValue;
};

export const calculateRemainingForecastOtherDirectCost = (data, key, odlId) => {
  let sumValue = 0;
  if (data && data.otherDirectLabourDetailList)
    data.otherDirectLabourDetailList
      .filter((val) => val.odlId === odlId)
      .forEach((item) => {
        item.monthExpenseDetail.forEach((monthItem) => {
          if (
            monthItem.type.toLowerCase() === "forecast" &&
            (excludedItemsForMonthly.indexOf(monthItem.monthYear) < 0 ||
              monthItem.monthYear === "Other Year Forecast")
          )
            sumValue += Number(monthItem[key]) || 0;
        });
      });
  return sumValue;
};

export const calculateRemainingForecastOtherDirectCostTotal = (data, key) => {
  let sumValue = 0;
  if (data && data.otherDirectLabourDetailList)
    data.otherDirectLabourDetailList.forEach((item) => {
      item.monthExpenseDetail.forEach((monthItem) => {
        if (
          monthItem.type.toLowerCase() === "forecast" &&
          (excludedItemsForMonthly.indexOf(monthItem.monthYear) < 0 ||
            monthItem.monthYear === "Other Year Forecast")
        )
          sumValue += Number(monthItem[key]) || 0;
      });
    });
  if (data && data.adjustment)
    data.adjustment
      .filter(
        (item) =>
          item.type.toLowerCase() === "forecast" &&
          (excludedItemsForMonthly.indexOf(item.monthYear) < 0 ||
            item.monthYear === "Other Year Forecast"),
      )
      .forEach((val) => {
        sumValue += Number(val[key]) || 0;
      });
  return sumValue;
};

export const calculateItemTotalOtherDirectCost = (data, key, odlId) => {
  let sumValue = 0;
  if (data && data.otherDirectLabourDetailList)
    data.otherDirectLabourDetailList
      .filter((val) => val.odlId === odlId)
      .forEach((item) => {
        item.monthExpenseDetail.forEach((monthItem) => {
          if (excludedItemsForMonthlyOther.indexOf(monthItem.monthYear) < 0)
            sumValue += Number(monthItem[key]) || 0;
        });
      });
  return sumValue;
};

export const calculateItemTotalDirectOtherDirectCost = (data, key) => {
  let sumValue = 0;
  if (data && data.otherDirectLabourDetailList)
    data.otherDirectLabourDetailList.forEach((item) => {
      item.monthExpenseDetail.forEach((monthItem) => {
        if (excludedItemsForMonthlyOther.indexOf(monthItem.monthYear) < 0)
          sumValue += Number(monthItem[key]) || 0;
      });
    });
  if (data && data.adjustment)
    data.adjustment.forEach((val) => {
      if (excludedItemsForMonthlyOther.indexOf(val.monthYear) < 0)
        sumValue += Number(val[key]) || 0;
    });
  return sumValue;
};

//End of other direct cost calculations

//Start of margin calculations

export const calculateTotalMonthlyMargin = (
  directLaborData,
  otherDirectCostData,
  key,
  monthYear,
) => {
  let sumValue = 0;
  sumValue += calculateTotalDirectLabor(directLaborData, key, monthYear);
  sumValue += calculateTotalOtherDirectCost(
    otherDirectCostData,
    key,
    monthYear,
  );
  return sumValue;
};

export const calculateNetProfit = (
  directLaborData,
  otherDirectCostData,
  monthYear,
  type,
  revenueData,
) => {
  let totalBurdenCost = 0;
  let totalRevenue = 0;
  totalBurdenCost += calculateTotalDirectLabor(
    directLaborData,
    "burdenCost",
    monthYear,
  );
  totalBurdenCost += calculateTotalOtherDirectCost(
    otherDirectCostData,
    "burdenCost",
    monthYear,
  );
  if (type.toLowerCase() !== "forecast")
    totalRevenue += calculateMonthlyRevenueForMargin(revenueData, monthYear);
  else {
    totalRevenue += calculateTotalDirectLabor(
      directLaborData,
      "revenue",
      monthYear,
    );
    totalRevenue += calculateTotalOtherDirectCost(
      otherDirectCostData,
      "revenue",
      monthYear,
    );
  }
  return parseInt(totalRevenue) - parseInt(totalBurdenCost);
};

export const calculateNetProfitPecentage = (
  directLaborData,
  otherDirectCostData,
  monthYear,
  type,
  revenueData,
) => {
  const totalRevenue =
    type.toLowerCase() == "forecast"
      ? parseInt(
          calculateTotalMonthlyMargin(
            directLaborData,
            otherDirectCostData,
            "revenue",
            monthYear,
          ),
        )
      : parseInt(calculateMonthlyRevenueForMargin(revenueData, monthYear));
  if (totalRevenue > 0) {
    const val =
      (parseInt(
        calculateNetProfit(
          directLaborData,
          otherDirectCostData,
          monthYear,
          type,
          revenueData,
        ),
      ) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

export const calculateTotalRemainingForecastMargin = (
  directLaborData,
  otherDirectCostData,
  key,
) => {
  let sumValue = 0;
  sumValue += calculateRemainingForecastDirectLaborTotal(directLaborData, key);
  sumValue += calculateRemainingForecastOtherDirectCostTotal(
    otherDirectCostData,
    key,
  );
  return sumValue;
};

export const calculateTotalMarginTotal = (
  directLaborData,
  otherDirectCostData,
  key,
) => {
  let sumValue = 0;
  sumValue += calculateItemTotalDirectLaborTotal(directLaborData, key);
  sumValue += calculateItemTotalDirectOtherDirectCost(otherDirectCostData, key);
  return sumValue;
};

export const calculateNetProfitRemainingForecast = (
  directLaborData,
  otherDirectCostData,
) => {
  let totalBurdenCost = 0;
  let totalRevenue = 0;
  totalBurdenCost += calculateTotalRemainingForecastMargin(
    directLaborData,
    otherDirectCostData,
    "burdenCost",
  );
  totalRevenue += calculateTotalRemainingForecastMargin(
    directLaborData,
    otherDirectCostData,
    "revenue",
  );
  return parseInt(totalRevenue) - parseInt(totalBurdenCost);
};

export const calculateNetProfitTotal = (
  directLaborData,
  otherDirectCostData,
  revenueData,
) => {
  let totalBurdenCost = 0;
  let totalRevenue = 0;
  totalBurdenCost += calculateTotalMarginTotal(
    directLaborData,
    otherDirectCostData,
    "burdenCost",
  );
  totalRevenue += calculateTotalRemainingForecastMargin(
    directLaborData,
    otherDirectCostData,
    "revenue",
  );
  totalRevenue += calculateMarginITDTotal(revenueData);
  return parseInt(totalRevenue) - parseInt(totalBurdenCost);
};

export const calculateNetProfitPecentageRemainingForecast = (
  directLaborData,
  otherDirectCostData,
) => {
  const totalRevenue = parseInt(
    calculateTotalRemainingForecastMargin(
      directLaborData,
      otherDirectCostData,
      "revenue",
    ),
  );
  if (totalRevenue > 0) {
    const val =
      (parseInt(
        calculateNetProfitRemainingForecast(
          directLaborData,
          otherDirectCostData,
        ),
      ) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

export const calculateNetProfitPecentageTotal = (
  directLaborData,
  otherDirectCostData,
  revenueData,
) => {
  let totalRevenue = calculateTotalRemainingForecastMargin(
    directLaborData,
    otherDirectCostData,
    "revenue",
  );
  totalRevenue += calculateMarginITDTotal(revenueData);
  if (totalRevenue > 0) {
    const val =
      (parseInt(
        calculateNetProfitTotal(
          directLaborData,
          otherDirectCostData,
          revenueData,
        ),
      ) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

//End of margin calculations

//Start of main calculations

export const calculateDirectLaborMargin = (billRate, costRateLoaded) => {
  if (billRate === 0) return null;
  return Math.round(((billRate - costRateLoaded) / billRate) * 100) / 100;
};

export const calculateOtherDirectCostBurdenCost = (
  unburdenCost,
  gaRate,
  smAndH,
  expenseType,
) => {
  if (expenseType.toLowerCase() !== "subcontract")
    return unburdenCost + (unburdenCost * gaRate) / 100;
  else
    return (
      unburdenCost +
      (unburdenCost * smAndH) / 100 +
      (((unburdenCost * smAndH) / 100) * gaRate) / 100
    );
};

export const calculateOtherDirectCostRevenue = (
  reimbursement,
  markupAllowed,
  burdenCost,
  nonLaborPer,
) => {
  if (!reimbursement) {
    return 0;
  }
  if (reimbursement && !markupAllowed) {
    return burdenCost;
  }
  if (reimbursement && markupAllowed) {
    return burdenCost + (burdenCost * nonLaborPer) / 100;
  }
};

export const calculateDirectLaborCostRateUnloaded = (
  costRateLoadedUnloaded,
  isLaborEscalationApplied,
  laborEscalation,
  laborEscalationIteration = 1,
) => {
  let res = 0;
  if (isLaborEscalationApplied && laborEscalation) {
    const x = (100 + laborEscalation) / 100;
    res =
      Math.round(
        costRateLoadedUnloaded * Math.pow(x, laborEscalationIteration) * 100,
      ) / 100;
  } else res = Math.round(costRateLoadedUnloaded * 100) / 100;
  return res;
};

export const calculateDirectLaborBurdenCost = (
  hours,
  costRateLoaded,
  isLaborEscalationApplied,
  laborEscalation,
  laborEscalationIteration = 1,
  expenseDate,
  laborEscalationDate,
  startDate,
) => {
  // let burdenCost = hours * costRateLoaded;
  // if (isLaborEscalationApplied) {
  //   for (let i = 0; i < laborEscalationIteration; i++) {
  //     burdenCost +=
  //       Math.round(((burdenCost * laborEscalation) / 100) * 100) / 100;
  //   }
  // }
  // return burdenCost;
  let res = 0;
  if (isLaborEscalationApplied && laborEscalation && laborEscalationDate) {
    if (
      getMonthOnly(expenseDate) === getMonthOnly(laborEscalationDate)
      //    &&
      // new Date(expenseDate).getFullYear() ===
      //   new Date(billRateEscalationDate).getFullYear()
    ) {
      const laborDate =
        expenseDate.split("-")[0] +
        "-" +
        laborEscalationDate.split("-")[1] +
        "-" +
        laborEscalationDate.split("-")[2];
      const firstDayOfMonth =
        expenseDate.split("-")[0] + "-" + expenseDate.split("-")[1] + "-01";
      const nonCalcHours =
        daysBetweenDates(
          parseLocalDate(firstDayOfMonth) < parseLocalDate(startDate)
            ? startDate
            : firstDayOfMonth,
          laborDate,
        ) * workingHoursPerDay;
      if (nonCalcHours >= hours) {
        res = costRateLoaded * hours;
      } else {
        const x = (100 + laborEscalation) / 100;
        res =
          (Math.round(
            costRateLoaded * Math.pow(x, laborEscalationIteration - 1) * 100,
          ) /
            100) *
            nonCalcHours +
          (Math.round(
            costRateLoaded * Math.pow(x, laborEscalationIteration) * 100,
          ) /
            100) *
            (hours - nonCalcHours);
      }
    } else {
      const x = (100 + laborEscalation) / 100;
      res =
        (Math.round(
          costRateLoaded * Math.pow(x, laborEscalationIteration) * 100,
        ) /
          100) *
        hours;
    }
  } else res = (Math.round(costRateLoaded * 100) / 100) * hours;
  return res;
};

export const calculateDirectLaborRevenue = (
  type,
  billRate,
  hours,
  burdenCost,
  feeLabor,
  feeSubcon,
  employeeType,
  isIwo,
  billRateEscalation,
  billRateEscalationDate,
  expenseDate,
  isBillRateEscalationApplied = false,
  billRateEscalationIteration = 1,
  startDate,
) => {
  if (type.toLowerCase() === "cost plus") {
    // IWO rows are contractors in the system, but the feeLabor (not feeSubCon) rate applies to
    // their revenue — same "treat as employee" rule applied to cost rate/burden elsewhere.
    if ((employeeType && employeeType.toLowerCase() === "employee") || isIwo)
      return burdenCost + (burdenCost * feeLabor) / 100;
    else return burdenCost + (burdenCost * feeSubcon) / 100;
  } else {
    let res = 0;
    if (
      isBillRateEscalationApplied &&
      billRateEscalation &&
      billRateEscalationDate
    ) {
      if (
        getMonthOnly(expenseDate) === getMonthOnly(billRateEscalationDate)
        //    &&
        // new Date(expenseDate).getFullYear() ===
        //   new Date(billRateEscalationDate).getFullYear()
      ) {
        const billRateDate =
          expenseDate.split("-")[0] +
          "-" +
          billRateEscalationDate.split("-")[1] +
          "-" +
          billRateEscalationDate.split("-")[2];
        const firstDayOfMonth =
          expenseDate.split("-")[0] + "-" + expenseDate.split("-")[1] + "-01";

        const nonCalcHours =
          daysBetweenDates(
            parseLocalDate(firstDayOfMonth) < parseLocalDate(startDate)
              ? startDate
              : firstDayOfMonth,
            billRateDate,
          ) * workingHoursPerDay;

        if (nonCalcHours >= hours) {
          res = billRate * hours;
        } else {
          const x = (100 + billRateEscalation) / 100;
          res =
            (Math.round(
              billRate * Math.pow(x, billRateEscalationIteration - 1) * 100,
            ) /
              100) *
              nonCalcHours +
            (Math.round(
              billRate * Math.pow(x, billRateEscalationIteration) * 100,
            ) /
              100) *
              (hours - nonCalcHours);
        }
      } else {
        const x = (100 + billRateEscalation) / 100;
        res =
          (Math.round(
            billRate * Math.pow(x, billRateEscalationIteration) * 100,
          ) /
            100) *
          hours;
      }
    } else res = billRate * hours;
    return res;
  }
};

export const calculateDirectLaborBurdenCostOT = (
  hours = 0,
  costRateLoaded,
  isLaborEscalationApplied,
  laborEscalation,
  laborEscalationIteration = 1,
  laborEscalationDate,
  fixedAmt = 0,
  factor = 1,
) => {
  let res = 0;
  if (isLaborEscalationApplied && laborEscalation && laborEscalationDate) {
    const x = (100 + laborEscalation) / 100;
    res =
      (Math.round(
        costRateLoaded * Math.pow(x, laborEscalationIteration) * 100,
      ) /
        100) *
        hours *
        factor +
      hours * fixedAmt;
  } else
    res =
      (Math.round(costRateLoaded * 100) / 100) * hours * factor +
      hours * fixedAmt;
  return res;
};

export const calculateDirectLaborRevenueOT = (
  type,
  billRate,
  hours = 0,
  billRateEscalation,
  billRateEscalationDate,
  isBillRateEscalationApplied = false,
  billRateEscalationIteration = 1,
) => {
  if (type.toLowerCase() === "cost plus") {
    return 0;
  } else {
    let res = 0;
    if (
      isBillRateEscalationApplied &&
      billRateEscalation &&
      billRateEscalationDate
    ) {
      const x = (100 + billRateEscalation) / 100;
      res =
        (Math.round(billRate * Math.pow(x, billRateEscalationIteration) * 100) /
          100) *
        hours;
    } else res = billRate * hours;
    return res;
  }
};

//End of main calculations

//Start of revenue table calculations

export const calculateTotalRevenueForCLIN = (
  clin,
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (directLaborData && directLaborData.getDirectLaborDetailList)
    directLaborData.getDirectLaborDetailList
      .filter((val) => val.clin.startsWith(clin))
      .forEach((val) => {
        val.monthExpenseDetail.forEach((item) => {
          if (excludedItemsForMonthly.indexOf(item.monthYear) < 0) {
            revenue += item.revenue;
          }
        });
      });
  if (otherDirectCostData && otherDirectCostData.otherDirectLabourDetailList)
    otherDirectCostData.otherDirectLabourDetailList
      .filter((val) => val.clin.startsWith(clin))
      .forEach((val) => {
        val.monthExpenseDetail.forEach((item) => {
          if (excludedItemsForMonthly.indexOf(item.monthYear) < 0) {
            revenue += item.revenue;
          }
        });
      });
  return Math.round(Number(revenue) * 100) / 100;
};

export const calculateTotalContractFunded = (data, key) => {
  let val = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      val += item[key];
    });
  return Math.round(Number(val) * 100) / 100;
};

export const calculateTotalEstCompletion = (
  data,
  directLaborData,
  otherDirectCostData,
) => {
  let val = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      val += calculateTotalRevenueForCLIN(
        item.clin,
        directLaborData,
        otherDirectCostData,
      );
    });
  return Math.round(Number(val) * 100) / 100;
};

export const calculateMonthlyRevenueForCLIN = (
  clin,
  monthYear,
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (directLaborData && directLaborData.getDirectLaborDetailList)
    directLaborData.getDirectLaborDetailList
      .filter((val) => val.clin.startsWith(clin))
      .forEach((val) => {
        val.monthExpenseDetail.forEach((item) => {
          if (item.monthYear === monthYear) {
            revenue += item.revenue;
          }
        });
      });
  if (otherDirectCostData && otherDirectCostData.otherDirectLabourDetailList)
    otherDirectCostData.otherDirectLabourDetailList
      .filter((val) => val.clin.startsWith(clin))
      .forEach((val) => {
        val.monthExpenseDetail.forEach((item) => {
          if (item.monthYear === monthYear) {
            revenue += item.revenue;
          }
        });
      });
  return Math.round(Number(revenue) * 100) / 100;
};

export const calculateMonthlyRevenue = (
  monthYear,
  data,
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      revenue += calculateMonthlyRevenueForCLIN(
        item.clin,
        monthYear,
        directLaborData,
        otherDirectCostData,
      );
    });
  return Math.round(Number(revenue) * 100) / 100;
};

export const calculateRemainingForecastRevenueForCLIN = (
  clin,
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (directLaborData && directLaborData.getDirectLaborDetailList)
    directLaborData.getDirectLaborDetailList
      .filter((val) => val.clin.startsWith(clin))
      .forEach((val) => {
        val.monthExpenseDetail.forEach((item) => {
          if (
            (excludedItemsForMonthly.indexOf(item.monthYear) < 0 &&
              item.type.toLowerCase() === "forecast") ||
            item.monthYear === "Other Year Forecast"
          ) {
            revenue += item.revenue;
          }
        });
      });
  if (otherDirectCostData && otherDirectCostData.otherDirectLabourDetailList)
    otherDirectCostData.otherDirectLabourDetailList
      .filter((val) => val.clin.startsWith(clin))
      .forEach((val) => {
        val.monthExpenseDetail.forEach((item) => {
          if (
            (excludedItemsForMonthly.indexOf(item.monthYear) < 0 &&
              item.type.toLowerCase() === "forecast") ||
            item.monthYear === "Other Year Forecast"
          ) {
            revenue += item.revenue;
          }
        });
      });
  return Math.round(Number(revenue) * 100) / 100;
};

export const calculateRemainingForecastRevenue = (
  data,
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      revenue += calculateRemainingForecastRevenueForCLIN(
        item.clin,
        directLaborData,
        otherDirectCostData,
      );
    });
  return Math.round(Number(revenue) * 100) / 100;
};

export const calculateRevenueAdjustementForMonth = (
  monthYear,
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (directLaborData && directLaborData.adjustment)
    directLaborData.adjustment.forEach((item) => {
      if (item.monthYear === monthYear) {
        revenue += item.revenue;
      }
    });
  if (otherDirectCostData && otherDirectCostData.adjustment)
    otherDirectCostData.adjustment.forEach((item) => {
      if (item.monthYear === monthYear) {
        revenue += item.revenue;
      }
    });
  return revenue;
};

export const calculateRevenueAdjustmentITD = (
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (directLaborData && directLaborData.adjustment)
    directLaborData.adjustment.forEach((item) => {
      if (
        (item.type.toLowerCase() !== "forecast" &&
          excludedItemsForMonthly.indexOf(item.monthYear) < 0) ||
        item.monthYear === "Other Year Actual"
      ) {
        revenue += item.revenue;
      }
    });
  if (otherDirectCostData && otherDirectCostData.adjustment)
    otherDirectCostData.adjustment.forEach((item) => {
      if (
        (item.type.toLowerCase() !== "forecast" &&
          excludedItemsForMonthly.indexOf(item.monthYear) < 0) ||
        item.monthYear === "Other Year Actual"
      ) {
        revenue += item.revenue;
      }
    });
  return revenue;
};

export const calculateRevenueAdjustmentRemainingForecast = (
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  if (directLaborData && directLaborData.adjustment)
    directLaborData.adjustment.forEach((item) => {
      if (
        (item.type.toLowerCase() === "forecast" &&
          excludedItemsForMonthly.indexOf(item.monthYear) < 0) ||
        item.monthYear === "Other Year Forecast"
      ) {
        revenue += item.revenue;
      }
    });
  if (otherDirectCostData && otherDirectCostData.adjustment)
    otherDirectCostData.adjustment.forEach((item) => {
      if (
        (item.type.toLowerCase() === "forecast" &&
          excludedItemsForMonthly.indexOf(item.monthYear) < 0) ||
        item.monthYear === "Other Year Forecast"
      ) {
        revenue += item.revenue;
      }
    });
  return revenue;
};

export const calculateRevenueAdjustmentTotal = (
  directLaborData,
  otherDirectCostData,
) => {
  let revenue = 0;
  revenue += calculateRevenueAdjustmentITD(
    directLaborData,
    otherDirectCostData,
  );
  revenue += calculateRevenueAdjustmentRemainingForecast(
    directLaborData,
    otherDirectCostData,
  );
  return revenue;
};

//End of revenue table calculations

//Start of FFP revenue table calculations

export const calculateFFPESTRevenueById = (val, key) => {
  let revenue = 0;
  val.monthExpenseDetail.forEach((item) => {
    if (
      IncludeItemsForTotal.indexOf(item.monthYear) >= 0 ||
      (item.expenseDate && item.type.toLowerCase() === "forecast")
    )
      revenue += item[key];
  });
  return revenue;
};

export const calculateFFPTotalESTRevenue = (data) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      revenue += calculateFFPESTRevenueById(item, "revenue");
      revenue += calculateFFPESTRevenueById(item, "adjustmentRevenue");
    });
  return revenue;
};

export const calculateFFPTotalESTRevenueByMonth = (data, monthYear) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((val) => {
      val.monthExpenseDetail.forEach((item) => {
        if (item.monthYear === monthYear) revenue += item.adjustedRevenue;
      });
    });
  return revenue;
};

export const calculateFFPForecastRevenueById = (val, key) => {
  let revenue = 0;
  val.monthExpenseDetail.forEach((item) => {
    if (
      excludedItemsForMonthlyForecast.indexOf(item.monthYear) < 0 &&
      item.type.toLowerCase() === "forecast"
    )
      revenue += item[key];
  });
  return revenue;
};

export const calculateFFPYTDRevenueById = (val, key) => {
  let revenue = 0;
  val.monthExpenseDetail.forEach((item) => {
    if (item.monthYear === "Other Year Actual" || item.monthYear === "ITD")
      revenue += item[key];
  });
  return revenue;
};

export const calculateFFPTotalYTDRevenue = (data) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      revenue += calculateFFPYTDRevenueById(item, "revenue");
      revenue += calculateFFPYTDRevenueById(item, "adjustmentRevenue");
    });
  return revenue;
};

export const calculateFFPTotalForecastRevenue = (data) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((item) => {
      revenue += calculateFFPForecastRevenueById(item, "revenue");
      revenue += calculateFFPForecastRevenueById(item, "adjustmentRevenue");
    });
  return revenue;
};

//End of FFP revenue table calculations

//Start of FFP margin table calculations

export const calculateNetProfitFFP = (
  reveunueData,
  directLaborData,
  otherDirectCostData,
  monthYear,
) => {
  let totalBurdenCost = 0;
  let totalRevenue = 0;
  totalBurdenCost += calculateTotalDirectLabor(
    directLaborData,
    "burdenCost",
    monthYear,
  );
  totalBurdenCost += calculateTotalOtherDirectCost(
    otherDirectCostData,
    "burdenCost",
    monthYear,
  );
  totalRevenue += calculateFFPTotalESTRevenueByMonth(reveunueData, monthYear);
  return parseInt(totalRevenue) - parseInt(totalBurdenCost);
};

export const calculateNetProfitPecentageFFP = (
  reveunueData,
  directLaborData,
  otherDirectCostData,
  monthYear,
) => {
  const totalRevenue = parseInt(
    calculateFFPTotalESTRevenueByMonth(reveunueData, monthYear),
  );
  if (totalRevenue > 0) {
    const val =
      (parseInt(
        calculateNetProfitFFP(
          reveunueData,
          directLaborData,
          otherDirectCostData,
          monthYear,
        ),
      ) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

export const calculateNetProfitRemainingForecastFFP = (
  reveunueData,
  directLaborData,
  otherDirectCostData,
) => {
  let totalBurdenCost = 0;
  let totalRevenue = 0;
  totalBurdenCost += calculateTotalRemainingForecastMargin(
    directLaborData,
    otherDirectCostData,
    "burdenCost",
  );
  totalRevenue += calculateFFPTotalForecastRevenue(reveunueData);
  return parseInt(totalRevenue) - parseInt(totalBurdenCost);
};

export const calculateNetProfitTotalFFP = (
  reveunueData,
  directLaborData,
  otherDirectCostData,
) => {
  let totalBurdenCost = 0;
  let totalRevenue = 0;
  totalBurdenCost += calculateTotalMarginTotal(
    directLaborData,
    otherDirectCostData,
    "burdenCost",
  );
  totalRevenue += calculateFFPTotalESTRevenue(reveunueData);
  return parseInt(totalRevenue) - parseInt(totalBurdenCost);
};

export const calculateNetProfitPecentageRemainingForecastFFP = (
  reveunueData,
  directLaborData,
  otherDirectCostData,
) => {
  const totalRevenue = parseInt(calculateFFPTotalForecastRevenue(reveunueData));
  if (totalRevenue > 0) {
    const val =
      (parseInt(
        calculateNetProfitRemainingForecastFFP(
          reveunueData,
          directLaborData,
          otherDirectCostData,
        ),
      ) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

export const calculateNetProfitPecentageTotalFFP = (
  reveunueData,
  directLaborData,
  otherDirectCostData,
) => {
  const totalRevenue = parseInt(calculateFFPTotalESTRevenue(reveunueData));
  if (totalRevenue > 0) {
    const val =
      (parseInt(
        calculateNetProfitTotalFFP(
          reveunueData,
          directLaborData,
          otherDirectCostData,
        ),
      ) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

//End of FFP margin table calculations

export const calculateMonthlyRevenueForMargin = (data, monthYear) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((val) => {
      val.monthExpenseDetail.forEach((item) => {
        if (item.monthYear === monthYear) revenue += item.adjustedRevenue;
      });
    });
  return revenue;
};

export const calculateMarginITDTotal = (data) => {
  let revenue = 0;
  if (data && data.revenueDetailList)
    data.revenueDetailList.forEach((val) => {
      val.monthExpenseDetail.forEach((item) => {
        if (item.monthYear === "ITD" || item.monthYear === "Other Year Actual")
          revenue += item.revenue;
      });
    });
  return revenue;
};

export const calculateITDMarginNetProfit = (revenueData, marginData) => {
  if (
    marginData &&
    marginData.total &&
    marginData.total.filter(
      (val) => val.monthYear === "ITD" || val.monthYear === "Other Year Actual",
    ).length > 0
  )
    return (
      calculateMarginITDTotal(revenueData) -
      marginData.total.filter((val) => val.monthYear === "ITD")[0].burdenCost -
      marginData.total.filter((val) => val.monthYear === "Other Year Actual")[0]
        .burdenCost
    );
  return 0;
};

export const calculateNetProfitPecentageITD = (revenueData, marginData) => {
  let totalRevenue = parseInt(calculateMarginITDTotal(revenueData));
  if (totalRevenue > 0) {
    const val =
      (parseInt(calculateITDMarginNetProfit(revenueData, marginData)) /
        totalRevenue) *
      100;
    return Math.round(val * 100) / 100;
  }
  return 0;
};

export const roundTwoDecimals = (value) => {
  if (!isNaN(value)) return Math.round(value * 100) / 100;
  else return value;
};

export const calculateCostRateLoaded = (
  value,
  employeeType,
  isIwo,
  fringe,
  oh,
  smAndH,
  gaRate,
) => {
  let rate = value;
  // IWO rows are contractors in the system, but their cost rate should still be loaded using
  // the employee fringe/OH/GA path — same "treat as employee" rule calculateDirectLaborRevenue
  // applies for the feeLabor/feeSubCon split.
  if ((employeeType && employeeType.toLowerCase() === "employee") || isIwo) {
    const fringeValue = (value * fringe) / 100;
    const ohCost = (value + fringeValue) * (oh / 100);
    const gaRateCost = (value + fringeValue + ohCost) * (gaRate / 100);
    rate += fringeValue + ohCost + gaRateCost;
  } else {
    const smAndHCost = (value * smAndH) / 100;
    const gaRateCost = smAndHCost * (gaRate / 100);
    rate += smAndHCost + gaRateCost;
  }
  return Math.round(rate * 100) / 100;
};

export const calculateTotalHours = (directLaborData, type) => {
  let hours = 0;
  directLaborData.getDirectLaborDetailList.forEach((item) => {
    item.monthExpenseDetail.forEach((monthItem) => {
      if (
        (monthItem.type.toLowerCase() === type &&
          excludedItemsForMonthly.indexOf(monthItem.monthYear) < 0) ||
        (type === "forecast" &&
          monthItem.monthYear === "Other Year Forecast") ||
        (type === "actual" && monthItem.monthYear === "Other Year Actual")
      ) {
        hours += monthItem.hours + Number(monthItem.otHours);
      }
    });
  });
  return hours;
};

export const calculateFFPITDNetProfit = (revenueData, marginData) => {
  let revenue = 0;
  if (revenueData && revenueData.totalRevenue)
    revenueData.totalRevenue.forEach((item) => {
      if (item.monthYear === "ITD" || item.monthYear === "Other Year Actual")
        revenue += item.adjustedRevenue;
    });
  let burdenCost = 0;
  if (marginData && marginData.total)
    marginData.total.forEach((item) => {
      if (item.monthYear === "ITD" || item.monthYear === "Other Year Actual")
        burdenCost += item.burdenCost;
    });
  return Number(revenue) - Number(burdenCost);
};

export const calculateFFPITDNetProfitPercentage = (revenueData, marginData) => {
  let perVal = 0;
  let revenue = 0;
  if (revenueData && revenueData.totalRevenue)
    revenueData.totalRevenue.forEach((item) => {
      if (item.monthYear === "ITD" || item.monthYear === "Other Year Actual")
        revenue += item.adjustedRevenue;
    });
  let profit = calculateFFPITDNetProfit(revenueData, marginData);
  if (revenue !== 0) {
    perVal = (profit / revenue) * 100;
  }
  return perVal;
};

export const getYearlyWorkingDays = (year) => {
  let count = 0;
  // Start date: January 1st of the given year
  const startDate = new Date(year, 0, 1);
  // End date: December 31st of the given year
  const endDate = new Date(year, 11, 31);

  const currentDate = new Date(startDate.getTime());
  while (currentDate <= endDate) {
    const dayOfWeek = currentDate.getDay();
    // Check if the day is not Sunday (0) and not Saturday (6)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count++;
    }
    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return count;
};

export const calculateEscalationIterationCount = (
  localEscalationDate,
  expenseDate,
) => {
  let laborEscalationIteration = 0;
  let escalationDate = new Date(
    localEscalationDate.getFullYear(),
    localEscalationDate.getMonth(),
    1,
  );
  while (escalationDate <= expenseDate) {
    laborEscalationIteration++;
    escalationDate = new Date(
      escalationDate.getFullYear() + 1,
      escalationDate.getMonth(),
      escalationDate.getDate(),
    );
  }
  return laborEscalationIteration;
};
